import React from "react";

export const LadderQuizIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.32"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM8.63271 3.8715C8.36675 3.37617 7.63328 3.37617 7.36731 3.8715L6.36575 5.7369L4.24235 6.1408C3.69955 6.24403 3.48015 6.87933 3.85005 7.27673L5.35575 8.89437L5.07918 11.0592C5.00955 11.6043 5.59618 12.0049 6.10485 11.7596L8.00001 10.8458L9.89518 11.7596C10.4038 12.0049 10.9905 11.6043 10.9208 11.0592L10.6443 8.89437L12.15 7.27673C12.5199 6.87933 12.3005 6.24403 11.7577 6.1408L9.63428 5.7369L8.63271 3.8715Z"
      fill="#078DEE"
    />
    <path
      d="M7.36727 3.8715C7.63324 3.37617 8.36671 3.37617 8.63267 3.8715L9.63424 5.7369L11.7576 6.1408C12.3004 6.24403 12.5198 6.87933 12.1499 7.27673L10.6442 8.89437L10.9208 11.0592C10.9904 11.6043 10.4038 12.0049 9.89514 11.7596L7.99997 10.8458L6.10481 11.7596C5.59614 12.0049 5.00951 11.6043 5.07914 11.0592L5.35571 8.89437L3.85001 7.27673C3.48011 6.87933 3.69951 6.24403 4.24231 6.1408L6.36571 5.7369L7.36727 3.8715Z"
      fill="#078DEE"
    />
  </svg>
);
